import React from 'react';
import { useTranslation } from 'react-i18next';
import TextInput from 'components/global/textInput/TextInput';
import { useAssessmentContext } from 'services/context/assessmentContext/useAssessmentContext';

const QuestionBanded = ({ formikProps }) => {
  const { t } = useTranslation();
  const {
    currentSlot,
    state: { currentSlotId }
  } = useAssessmentContext();
  const { content } = currentSlot.question;

  return (
    <TextInput
      description={t('openAnswerQuestion.enterAnswer')}
      formikProps={formikProps}
      label={content[0] ? content[0].text_display : 'No label given'}
      name={currentSlotId}
      placeholder={content[0] && content[0].placeholder}
      showInitialErrors
    />
  );
};

export default QuestionBanded;
